module.exports = __webpack_public_path__ + "img/login-car-v2.d3f74227.svg";